import React from "react";
import TextWidget from "../Widget/TextWidget";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import SocialWidget from "../Widget/SocialWidget";
import MenuWidget from "../Widget/MenuWidget";
const menuDataOne = [
  { title: "Fasilitas & Layanan", href: "/layanan" },
  { title: "Dokter", href: "/dokter" },
  { title: "Jadwal Dokter", href: "" },
  { title: "Pendaftaran", href: "/Pendaftaran" },
];

const menuDataTwo = [
  { title: "", href: "/" },
  { title: "", href: "/blog" },
  { title: "", href: "/" },
  { title: "", href: "/" },
];
const menuDataThree = [
  { title: "", href: "/" },
  { title: "", href: "/" },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_2 cs_type_1 cs_accent_bg cs_white_color">
      <div className="container">
        <div className="cs_footer_in">
          <div className="cs_footer_col">
            <div className="cs_footer_item">
              <TextWidget
                logoUrl="/images/logo1.png"
                text="Melayani dengan sepenuh hati"
              />
              <ContactInfoWidget />
            </div>
          </div>
          <div className="cs_footer_col">
            <div className="cs_footer_item">
              <MenuWidget data={menuDataOne} />
            </div>
          </div>
          <div className="cs_footer_col">
            <div className="cs_footer_item">
              <MenuWidget data={menuDataTwo} />
            </div>
          </div>
          <div className="cs_footer_col">
            <div className="cs_footer_item">
              <MenuWidget data={menuDataThree} />
              <SocialWidget />
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom">
        <div className="container">
          <div className="cs_copyright">Copyright © 2024 RS Mutiara Bunda.</div>
        </div>
      </div>
    </footer>
  );
}
